import React from 'react';

import PieChart from '@components/PieChart';

const TotalStyleChart = ({ orderSummary }) => {
	const getPercentageValue = (n1 = 0, n2 = 0) => {
		return (n1 / (n1 + n2)) * 100;
	};

	const generateChartData = () => {
		const nitexCount = getPercentageValue(orderSummary.noOfNitexStyle, orderSummary.noOfBuyerStyle);
		const buyerCount = getPercentageValue(orderSummary.noOfBuyerStyle, orderSummary.noOfNitexStyle);
		return {
			labels: ['Nitex Design', 'Buyer Design'],
			datasets: [
				{
					label: '',
					data: [nitexCount, buyerCount],
					backgroundColor: ['rgba(59, 130, 246, 1)', 'rgba(171, 213, 117, 1)'],
					borderWidth: 0
				}
			]
		};
	};

	return <PieChart data={generateChartData()} />;
};

export default TotalStyleChart;
